import { useContext } from 'react';
import { DataContex } from '../context/DataContext';

export const useAccessLevel = () => {
  const { userLevel } = useContext(DataContex);

  const canAccess = (resourceLevel) => {
    return userLevel >= resourceLevel;
  };

  return { canAccess };
}; 